import ACTIONS from "../actions/SourceActions";
import _ from "lodash";

const initialState = {
    source: {},
    dpInputFields: [],
    deleteSourceWarning: false,
}

const sourceDetailReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Details.LOAD_SOURCE_DETAIL: {
            let newState = _.cloneDeep(state);
            newState.source = action.payload.sourceDetail;
            newState.dpInputFields = action.payload.inputFields;
            return newState;
        }

        case ACTIONS.Details.DELETE_SOURCE_WARNING: {
            let newState = _.cloneDeep(state);
            newState.deleteSourceWarning = !newState.deleteSourceWarning;
            return newState;
        }

        case ACTIONS.Details.CLEAR_SOURCE_DETAILS: {
            return initialState;
        }

        default:
            return state
    }
};

export default sourceDetailReducer;
